import { render, staticRenderFns } from "./tjlxPieChart.vue?vue&type=template&id=c481a838"
import script from "./tjlxPieChart.vue?vue&type=script&lang=js"
export * from "./tjlxPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports